import React, { useContext } from 'react';
import { HeaderContext } from '@contexts/HeaderContext';

const HamburgerBtn = ({ closeButtonRef, siteName, liveChat }) => {
    const [{ isShowRightNav, isCloseButtonVisible }, dispatch] = useContext(HeaderContext);

    return (
        <a
            className="btn btn--nav"
            onClick={() => dispatch({ type: 'TOGGLE_RIGHT_NAV_SHOWING', value: !isShowRightNav })}
            // data-open={isShowRightNav}
            ref={closeButtonRef}
            data-visible={isCloseButtonVisible}
        >            
            <i className="iconani-nav">
                <i className="iconani-nav__stick" />
                <i className="iconani-nav__stick" />
                <i className="iconani-nav__stick" />
            </i>
        </a>

    );
};

export default HamburgerBtn;
